module.exports = __webpack_public_path__ + "img/Huygenstijdmachine_Provincie-Zuid-Holland.3e466ee1.svg";